import { Box, Typography } from "@mui/material";
import { listTimeKeepingHRSelector } from "modules/DeclareLeave/redux/selector";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import pxToRem from "theme/base/pxToRem";

const useColumns = () => {
  const { data } = useSelector(listTimeKeepingHRSelector);

  const listHeaderPlus = useMemo(() => {
    if (!data && !data?.length) return [];
    if (!data[0]!?.leaveReasons && !data[0]!?.leaveReasons?.length) return [];
    return data[0]!?.leaveReasons?.map((it, idx) => ({
      id: it?.reasonCode,
      accessorKey: it?.reasonCode,
      header: it?.reasonCode,
      width: 60,
      minSize: 60,
      enableSorting: false,

      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",
            textAlign: "center",
            textWrap: "wrap",
            whiteSpace: "wrap",
            textOverflow: "hidden",
          })}
        >
          {info?.row?.original?.leaveReasons[idx]?.totalDays}
        </Typography>
      ),
      footer: (props) => props.column.id,
      pinPosition: "left",
      headerStyle: {
        padding: 0,
        display: "flex",
        justifyContent: "center",
      },
      customStyle: {
        justifyContent: "center",
      },
    }));
  }, [data]);

  const columns = useMemo(() => {
    const cols: any[] = [
      {
        id: "workingAreaName",
        accessorKey: "workingAreaName",
        header: "Khu vực",
        footer: (props) => props.column.id,
        minSize: 80,
        width: 100,
        pinPosition: "center",
        enableSorting: false,
      },
      {
        id: "index",
        accessorKey: "index",
        header: "STT",
        width: 50,
        enableSorting: false,

        cell: (info) => (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              color: theme.palette.text.textPrimary,
              width: "100%",

              textAlign: "center",
            })}
          >
            {info.row.index + 1 < 10
              ? `0${info.row.index + 1}`
              : info.row.index + 1}
          </Typography>
        ),
        footer: (props) => props.column.id,
        pinPosition: "left",
      },
      {
        id: "employeeCode",
        accessorKey: "employeeCode",
        header: "Mã NV",
        minSize: 150,
        pinPosition: "left",
        enableSorting: false,
      },
      {
        id: "employeeName",
        accessorKey: "employeeName",
        header: "Tên nhân viên",
        footer: (props) => props.column.id,
        minSize: 150,
        pinPosition: "left",
        enableSorting: false,
      },
      {
        id: "positionName",
        accessorKey: "positionName",
        header: "Chức danh",
        footer: (props) => props.column.id,
        minSize: 150,
        pinPosition: "left",
        enableSorting: false,
      },
      {
        id: "deptNameLevel1",
        accessorKey: "deptNameLevel1",
        header: "Đơn vị cấp 1",
        footer: (props) => props.column.id,
        minSize: 150,
        pinPosition: "left",
        enableSorting: false,
      },
      {
        id: "deptNameLevel2",
        accessorKey: "deptNameLevel2",
        header: "Đơn vị cấp 2",
        footer: (props) => props.column.id,
        minSize: 150,
        pinPosition: "left",
        enableSorting: false,
      },
    ].concat(listHeaderPlus);

    cols.push({
      minSize: 150,
      id: "totalWorkDays",
      accessorKey: "totalWorkDays",
      header: "TỔNG CỘNG NGÀY CÔNG TÍNH LƯƠNG NS",
      width: 150,
      enableSorting: false,

      cell: (info) => (
        <Box
          sx={(theme) => ({
            background: theme.palette.colorsBase.gray_0,
            marginLeft: `-${pxToRem(15)}`,
            marginRight: `-${pxToRem(17)}`,
            width: `calc(100% + ${pxToRem(32)})`,
            height: `100%`,
            justifyContent: "center",
            padding: `${pxToRem(8)} ${pxToRem(16)}`,
          })}
        >
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              color: theme.palette.colorsBase.blue_0,
              width: "100%",

              textAlign: "center",
            })}
          >
            {info?.getValue() || 0}
          </Typography>
        </Box>
      ),
      footer: (props) => props.column.id,
      pinPosition: "center",
    });

    return cols;
  }, [listHeaderPlus]);
  return { columns };
};
export default useColumns;
